import React, { useState } from "react";
import "../css/ModalPopUp.css";
import MasjidMiftahurrahmahSlider from "./slider/MasjidMiftahurrahmahSlider";
import Footer from "../../../../../../Footer";

export default function MasjidMiftahurrahmah() {

  return (
    <div className="modal-img">
        <MasjidMiftahurrahmahSlider/>
        <Footer/>
    </div>
  );
}